import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useMe } from '@/queries/auth'

type AuthGuardProps = { children: ReactNode }

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { data, isLoading } = useMe()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-sm text-gray-500">Yükleniyor...</div>
      </div>
    )
  }

  if (!data?.user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
